import { useVariantConfigurationContext } from 'modules/experiments/contexts';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { VariantPillWrapper } from 'modules/experiments/components/ui/pills/Styled';
import { AccordionHeader } from 'ui/accordion';
import { Bold, ErrorLabel, StyledBadge } from 'ui/accordion/ErrorAccordion/ErrorAccordion.styled';
import { AccordionTypes, ErrorTypes } from 'ui/accordion/types';
import { ErrorWarningBannerText } from 'ui/accordion/ErrorAccordion/ErrorWarningBannerText';
import {
  ErrorHeaderText,
  ErrorListWrapper,
  ErrorSectionHeaderWrapper,
  StyledAccordion,
  StyledAccordionContent,
} from './Styled';

export const ErrorAccordion = () => {
  const { t } = useExperimentsTranslations();
  const { variantIssueCount, variantIssues } = useVariantConfigurationContext();

  if (!variantIssueCount) return <></>;

  return (
    <StyledAccordion data-test="variant-error-accordion" accordionType={AccordionTypes.Error}>
      <AccordionHeader data-test="variant-error-accordion-header">
        <ErrorLabel>
          <div>
            <Bold data-test="error-count">
              {t('errorAccordion.issue', { count: variantIssueCount })}
            </Bold>{' '}
            {t('errorAccordion.title')}
          </div>
          <StyledBadge variant="" data-test="badge-errors" data-type={ErrorTypes.Error}>
            {t('errorAccordion.error', { count: variantIssueCount })}
          </StyledBadge>
        </ErrorLabel>
      </AccordionHeader>
      <StyledAccordionContent>
        {variantIssues.map((variantIssue) => (
          <div key={variantIssue.alphabet}>
            <ErrorSectionHeaderWrapper>
              <VariantPillWrapper textColor={variantIssue.textColor} bgColor={variantIssue.bgColor}>
                {variantIssue.alphabet}
              </VariantPillWrapper>
              <ErrorHeaderText>{variantIssue.name}</ErrorHeaderText>
            </ErrorSectionHeaderWrapper>
            <ErrorListWrapper>
              {variantIssue.issueList.map((issue, index) => (
                <ErrorWarningBannerText
                  data-test="error-banner"
                  key={`error-${index}`}
                  type={ErrorTypes.Error}
                  message={issue.errorMessage}
                  subMessage={issue.subMessage}
                />
              ))}
            </ErrorListWrapper>
          </div>
        ))}
      </StyledAccordionContent>
    </StyledAccordion>
  );
};
